// src/utils/countries.js
import countries from "i18n-iso-countries";
import es from "i18n-iso-countries/langs/es.json";

// registrar español
countries.registerLocale(es);

/** Devuelve [{ code: 'MX', name: 'México' }, ...] */
export function getCountriesES() {
  const names = countries.getNames("es", { select: "official" }) || {};
  return Object.entries(names)
    .map(([code, name]) => ({ code: code.toUpperCase(), name }))
    .sort((a, b) => a.name.localeCompare(b.name, "es"));
}

/** Normaliza a ISO Alpha-2 (si pasas nombre en ES/EN te da su código) */
export function normalizeCountryCode(input) {
  if (!input) return "";
  const raw = String(input).trim();

  // Ya es alpha-2?
  const up = raw.toUpperCase();
  const isAlpha2 = /^[A-Z]{2}$/.test(up);
  if (isAlpha2 && (countries.getName(up, "es") || countries.getName(up, "en"))) {
    return up;
  }

  // Intenta por nombre ES o EN
  const byEs = countries.getAlpha2Code(raw, "es");
  if (byEs) return byEs.toUpperCase();

  const byEn = countries.getAlpha2Code(raw, "en");
  if (byEn) return byEn.toUpperCase();

  // Fallback (no reconocido): devuelve input en mayúsculas (o vacío)
  return up.length <= 3 ? up : "";
}